import { Flame, Clock, Bike, ShieldCheck } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const facts = [
  { icon: Flame, big: "1–6", label: "Burner Configurations", sub: "Flexible per kitchen unit" },
  { icon: Clock, big: "24/7", label: "Access Available", sub: "Secure, round-the-clock entry" },
  { icon: Bike, big: "3", label: "Delivery Platforms", sub: "Talabat · Deliveroo · Noon" },
  { icon: ShieldCheck, big: "Licensed", label: "Dubai Municipality Compliant", sub: "Inspected & approved facility" },
];

export default function Stats() {
  return (
    <section className="border-y border-gold/15 py-16 md:py-20" data-testid="stats-section">
      <div className="mx-auto grid max-w-7xl grid-cols-2 gap-y-12 px-5 md:px-8 lg:grid-cols-4">
        {facts.map((f, i) => (
          <Reveal
            key={f.label}
            delay={i * 0.1}
            className={`flex flex-col items-center text-center ${i > 0 ? "lg:border-l lg:border-gold/15" : ""}`}
          >
            <f.icon size={18} strokeWidth={1.5} className="mb-4 text-gold/70" />
            <span
              className="font-serif text-4xl font-medium text-gold md:text-5xl"
              data-testid={`fact-${f.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
            >
              {f.big}
            </span>
            <span className="mt-3 text-[10px] uppercase tracking-[0.26em] text-white/70">{f.label}</span>
            <span className="mt-1 text-[10px] font-light text-white/40">{f.sub}</span>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
